// This icon file is generated automatically.
var PtoUserOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 32 32", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M26.83 23.86a11.69 11.69 0 00-6.25-6.25l-.04-.02A7.73 7.73 0 0016 3.56a7.75 7.75 0 00-4.54 14.04l-.04.01a11.64 11.64 0 00-6.25 6.26c-.58 1.36-.89 2.82-.92 4.31 0 .14.1.26.25.26h1.88c.13 0 .24-.11.25-.25a9.32 9.32 0 012.74-6.38A9.31 9.31 0 0116 19.06c2.5 0 4.86.98 6.63 2.75a9.32 9.32 0 012.75 6.38c0 .14.1.25.25.25h1.87c.14 0 .25-.12.25-.26-.03-1.5-.34-2.95-.92-4.32zM16 16.7a5.34 5.34 0 01-5.38-5.38A5.34 5.34 0 0116 5.94a5.34 5.34 0 015.38 5.37A5.34 5.34 0 0116 16.7z", "fill-rule": "nonzero" } }] }, "name": "pto-user", "theme": "outlined" };
export default PtoUserOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PtoUserOutlined.js
// module id = 3935
// module chunks = 0